import { useEffect } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import { useAppDispatch } from 'src/store';
import { ref, off, onValue, DatabaseReference } from 'firebase/database';
import { database } from 'src/libs/firebase/firebase';
import { NotificationBadge } from 'src/type/notification';
import {
  setTransactionBadgeAction,
  setNotificationBadgeAction,
} from 'src/store/slices/badge-slice';
import { RtTransactionBadgeType } from 'src/type/transaction';

type Props = {
  children: React.ReactNode;
};

export default function RealtimeDatabaseProvider({ children }: Props) {
  const dispatch = useAppDispatch();
  const { authenticated } = useAuthContext();

  useEffect(() => {
    let onValueRef: DatabaseReference | undefined;

    if (authenticated) {
      onValueRef = ref(database, `notifications/admin`);
      onValue(onValueRef, async (snapshot) => {
        if (snapshot.exists()) {
          const val: NotificationBadge = snapshot.val();
          dispatch(setNotificationBadgeAction(val));
        }
      });
    }

    return () => {
      if (onValueRef) {
        off(onValueRef);
      }
    };
  }, [authenticated]);

  useEffect(() => {
    let onValueRef: DatabaseReference | undefined;

    if (authenticated) {
      onValueRef = ref(database, `transactions`);
      onValue(onValueRef, async (snapshot) => {
        if (snapshot.exists()) {
          const val: RtTransactionBadgeType = snapshot.val();
          dispatch(
            setTransactionBadgeAction({
              redeem: val?.REDEEM?.PENDING || 0,
              topup: val?.TOPUP_CREDIT?.PENDING || 0,
              withdraw: val?.WITHDRAW_CREDIT?.PENDING || 0,
              position: (val?.BUY_POSITION?.PENDING || 0) + (val?.SELL_POSITION?.PENDING || 0),
              topupDeposit: val?.TOPUP_DEPOSIT?.PENDING || 0,
              deposit: val?.DEPOSIT?.PENDING || 0,
              almostExpired: val?.ALMOST_EXPIRED_POSITIONS?.PENDING || 0,
            })
          );
        }
      });
    }

    return () => {
      if (onValueRef) {
        off(onValueRef);
      }
    };
  }, [authenticated]);

  return children;
}
